import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { KpiChart } from '@app/models/kpi-chart';
import { KpiChartGroup } from '@app/models/kpi-chart-group';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnInit {

  @Input() chart: KpiChartGroup;
  max: KpiChart;
  min: KpiChart;
  chartItems: KpiChart[];
  chartFix: KpiChart[];
  constructor() { }

  ngOnInit(): void {
    if (this.chart && this.chart.ChartItems) {
      this.max = Math.max.apply(Math, this.chart.ChartItems.map(c => c.ChartValue));
      this.min = Math.min.apply(Math, this.chart.ChartItems.map(c => c.ChartValue));
      const sum = this.chart.ChartItems.reduce((prev, cur) => prev + cur.ChartValue, 0);

      this.chart.ChartItems.forEach((item, i) => {
        item.GraphValue = (360 / sum) * item.ChartValue;

        if (i > 0) {
          if (this.chart.ChartItems[i - 1].Repeat) {
            item.PieChartDegree = (this.chart.ChartItems[i - 1].GraphValue * 2) + this.chart.ChartItems[i - 1].PieChartDegree;
          } else {
            item.PieChartDegree = this.chart.ChartItems[i - 1].GraphValue + this.chart.ChartItems[i - 1].PieChartDegree;
          }
        } else {
          // first pie chart value set to start from 0 degree
          item.PieChartDegree = 0;
        }

        if (item.GraphValue > 180) {
          const divided_val = item.GraphValue / 2;
          item.GraphValue = divided_val;
          item.Repeat = true;
        }
        console.log(item.GraphValue);
      });

      this.chartItems = this.chart.ChartItems;
    }
  }
  getStyle() {
    const style = '{\'transform\': \'rotate(90deg)\'}';
    return style;
  }

  getPieChartColor(index) {
    if (index > 9) {
      return 'pie-chart-color-default';
    }

    return 'pie-chart-color' + (index + 1);
  }
}
@NgModule({
  declarations: [PieChartComponent],
  exports: [PieChartComponent],
  imports: [
    CommonModule,
    LinkModule
  ]
})
export class PieChartModule { }
